<template>
    <div class="crop">
        <button class="primary-outline sm mr-2" v-on:click="selectPhoto"><i class="fa-solid fa-camera"></i> Upload a
            Photo</button>
        <div><small>(Photo must be color, JPG format, no smaller than 836px wide by 936px tall, and no larger than 1250px
                wide by 1400px tall.)</small></div>
        <div class="crop-error" v-if="crop_error">{{ error_message }}</div>
        <input type="file" name="photo" id="photo" v-on:change="getImage" />
        <div class="crop-container" v-show="showCropper">
            <div class="crop-tool">
                <div class="crop-options">
                    <i class="fa-solid fa-circle-plus" v-on:click="zoomIn"></i>
                    <i class="fa-solid fa-circle-minus" v-on:click="zoomOut"></i>
                    <i class="fa-solid fa-circle-check" v-on:click="crop"></i>
                    <i class="fa-solid fa-circle-xmark" v-on:click="cancel"></i>
                </div>
                <img id="crop-image" src="" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
import Cropper from "cropperjs";

export default {
    name: "ButtonCrop",
    data() {
        return {
            selected_data: "",
            cropper: null,
            scale: 1,
            showCropper: false,
            original_image: null,
            cropped_image: null,
            crop_error: false,
            error_message: "",
        };
    },
    mounted() { },
    methods: {
        selectPhoto() {
            document.getElementById("photo").click();
        },
        zoomIn() {
            this.scale = this.scale + 0.02;
            this.cropper.scale(this.scale);
        },
        zoomOut() {
            this.scale = this.scale - 0.02;

            if (this.scale < 0) {
                this.scale = 0;
            }

            this.cropper.scale(this.scale);
        },
        getImage(e) {
            const vue = this;
            const reader = new FileReader();

            this.crop_error = false;
            this.error_message = "";

            reader.onload = function (event) {
                const img = new Image();

                if (e.target.files[0].type != "image/jpeg") {
                    vue.crop_error = true;
                    vue.error_message = "The photo must be in JPG format.";
                    return;
                }

                img.src = event.target.result;

                setTimeout(function () {
                    if (img.width < 836 || img.height < 936) {
                        vue.crop_error = true;
                        vue.error_message = "The photo must be a minimum 836px wide & 936px tall. The uploaded photo is " + img.width + "px wide & " + img.height + "px tall.";
                        return;
                    }

                    if (img.width > 1250 || img.height > 1400) {
                        vue.crop_error = true;
                        vue.error_message = "The photo must be a maximum 1250px wide & 1400px tall. The uploaded photo is " + img.width + "px wide & " + img.height + "px tall.";
                        return;
                    }

                    document.getElementById("crop-image").src = img.src;
                    vue.initCropper();
                }, 500);
            };

            reader.readAsDataURL(e.target.files[0]);
        },
        initCropper() {
            this.showCropper = true;

            const image = document.getElementById("crop-image");

            this.cropper = new Cropper(image, {
                aspectRatio: 209 / 234,
                cropBoxResizable: false,
                cropBoxMovable: false,
                viewMode: 1,
                ready() {
                    this.cropper.setDragMode("move");
                },
            });
        },
        crop() {
            const cropped_image = this.cropper.getCroppedCanvas({
                width: 836,
                height: 936,
                imageSmoothingQuality: "high",
            });

            this.cropped_image = cropped_image.toDataURL();

            const original_image = this.cropper.clear().getCroppedCanvas();

            this.original_image = original_image.toDataURL();

            this.emitter.emit("croppedImageUpdated", { original_image: this.original_image, cropped_image: this.cropped_image });

            this.showCropper = false;

            document.getElementById("photo").value = "";

            this.cropper.destroy();
        },
        cancel() {
            this.showCropper = false;

            document.getElementById("photo").value = "";

            this.cropper.destroy();
        },
    },
};
</script>

<style>
@import "https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.5.12/cropper.min.css";

.crop-container {
    position: fixed;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    z-index: 99999;
}

.cropper-bg {
    background-repeat: repeat;
}

.crop-tool {
    width: 375px;
    height: 420px;
}

.crop-options {
    display: flex;
    gap: 12px;
    align-items: center;
    background: #000000;
    padding: 6px;
    justify-content: space-around;
}

.crop-options i {
    cursor: pointer;
    font-size: 26px;
    color: #ffffff;
}

.crop-options i.fa-circle-plus {
    color: #ffffff;
}

.crop-options i.fa-circle-minus {
    color: #ffffff;
}

.crop-options i.fa-circle-check {
    color: #16a34a;
}

.crop-options i.fa-circle-xmark {
    color: #dc2626;
}

.crop input[type="file"] {
    display: none;
}

.crop-error {
    background: #dc2626;
    padding: 12px;
    color: #ffffff;
    margin-top: 12px;
}
</style>
